import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { BaseApiGuard } from "./base-api.guard";
import { Observable } from "rxjs";


@Injectable({ providedIn: "root" })
export class AnlageApiGuard extends BaseApiGuard  {
  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (this.perms.UserCan_AnlageAPI) {
      return true;
    }
    this.NavigateToFallbackModule();
    return false;
  }
}
